import { createContext, useContext } from "react";
import type { Me } from "./api.js";
import type { Session } from "../app/auth.js";

// ——— Le contexte de l'app : qui est connecté, dans quel espace ————————————————

/** Changer d'espace, en ajouter un, en renommer un : l'app (App.tsx) tient l'espace courant. */
export type WorkspaceActions = { choose: (id: string) => void; upsert: (w: Me["workspaces"][number], select?: boolean) => void };
export type AppState = { session: Session; me: Me | null; workspaceId: string | null; workspaces?: WorkspaceActions };
export const AppContext = createContext<AppState | null>(null);
export function useApp(): AppState {
  const a = useContext(AppContext);
  if (!a) throw new Error("AppContext absent");
  return a;
}

/** Le rôle dans l'espace : un relecteur regarde, il ne modifie pas. */
export function useCanEdit(): boolean {
  const { me, workspaceId } = useApp();
  return me?.workspaces.find((w) => w.id === workspaceId)?.role !== "reviewer";
}
